const DATE_INPUT_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const padTwo = (value) => String(value).padStart(2, "0");

export const parseLocalDateInput = (date) => {
  if (!date) return null;

  if (date instanceof Date) {
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const match = DATE_INPUT_PATTERN.exec(date);

  if (!match) {
    return null;
  }

  const [, year, month, day] = match;
  const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));

  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatLocalDateInput = (date = new Date()) => {
  const parsedDate = parseLocalDateInput(date);

  if (!parsedDate) return "";

  return [
    parsedDate.getFullYear(),
    padTwo(parsedDate.getMonth() + 1),
    padTwo(parsedDate.getDate()),
  ].join("-");
};

export const addLocalDays = (date, days) => {
  const parsedDate = parseLocalDateInput(date);

  if (!parsedDate) return null;

  return new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate() + days
  );
};

export const formatLocalDateDisplay = (date) => {
  const parsedDate = parseLocalDateInput(date);

  if (!parsedDate) return "";

  return parsedDate.toLocaleDateString("pt-BR");
};

export const buildLocalDateTime = (date, hour = "00:00") => {
  const parsedDate = parseLocalDateInput(date);

  if (!parsedDate || typeof hour !== "string") return null;

  const [hours, minutes] = hour.split(":").map(Number);

  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

  return new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate(),
    hours,
    minutes
  );
};
